import { useState } from "react";
import { ChevronLeft, ChevronRight, Star as StarIcon } from "lucide-react";
import { REVIEWS } from "../data/reviews";
import Reveal from "./Reveal";
import { Heart, Flower } from "./Doodles";
import { Star } from "./Illustrations";

export default function Reviews() {
  const [idx, setIdx] = useState(0);
  const next = () => setIdx((i) => (i + 1) % REVIEWS.length);
  const prev = () => setIdx((i) => (i - 1 + REVIEWS.length) % REVIEWS.length);

  return (
    <section className="relative py-24 md:py-36 px-5 md:px-10 overflow-hidden" data-testid="reviews">
      <Heart size={36} className="absolute top-16 left-[12%] wiggle hidden md:block" color="#DD2E20" />
      <Flower size={50} className="absolute top-24 right-[10%] wiggle hidden md:block" color="#F4C734" center="#DD2E20" />
      <Star size={22} className="absolute bottom-1/3 right-[6%] wiggle" color="#8BC547" />

      <div className="relative mx-auto max-w-[1100px]">
        <Reveal>
          <p className="eyebrow mb-4 text-center">Loved by parents</p>
        </Reveal>
        <Reveal delay={80}>
          <h2 className="font-serif text-3xl md:text-5xl lg:text-6xl leading-[1.05] tracking-[-0.025em] text-center max-w-[24ch] mx-auto">
            What other parents <span className="italic" style={{ color: "#DD2E20" }}>have to say.</span>
          </h2>
        </Reveal>

        <div className="relative mt-14 overflow-hidden">
          <div
            className="flex transition-transform duration-700"
            style={{ transform: `translateX(-${idx * 100}%)`, transitionTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)" }}
          >
            {REVIEWS.map((r, i) => (
              <article
                key={r.quote}
                className="min-w-full px-2 md:px-10"
                aria-hidden={i !== idx}
              >
                <div
                  className="rounded-[28px] p-8 md:p-14 text-center"
                  style={{ background: r.tone }}
                  data-testid={`review-${i}`}
                >
                  <div className="flex justify-center gap-1 mb-6">
                    {[0,1,2,3,4].map((s) => (
                      <StarIcon key={s} className="w-4 h-4 fill-[#2C2C2A] text-[#2C2C2A]" />
                    ))}
                  </div>
                  <p className="font-serif text-2xl md:text-4xl leading-[1.18] tracking-[-0.01em] max-w-[28ch] mx-auto">
                    "{r.quote}"
                  </p>
                  <p className="mt-7 text-[13px] text-[#2C2C2A]/75 uppercase tracking-[0.2em] font-medium">
                    {r.author} · {r.location}
                  </p>
                </div>
              </article>
            ))}
          </div>

          <div className="flex items-center justify-center gap-6 mt-8">
            <button onClick={prev} aria-label="Previous review" className="w-11 h-11 rounded-full bg-[#FAFAF7] border border-[#2C2C2A]/15 inline-flex items-center justify-center hover:bg-[#2C2C2A] hover:text-[#FAFAF7] transition-colors" data-testid="review-prev">
              <ChevronLeft className="w-4 h-4" />
            </button>
            <span className="text-[12px] text-[#595955] tabular-nums tracking-[0.2em]">{String(idx + 1).padStart(2, "0")} / {String(REVIEWS.length).padStart(2, "0")}</span>
            <button onClick={next} aria-label="Next review" className="w-11 h-11 rounded-full bg-[#FAFAF7] border border-[#2C2C2A]/15 inline-flex items-center justify-center hover:bg-[#2C2C2A] hover:text-[#FAFAF7] transition-colors" data-testid="review-next">
              <ChevronRight className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
